import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, Platform, App } from 'ionic-angular';

import { LoginPage } from '../login/login';

/**
 * Generated class for the LogoutModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-logout-modal',
	templateUrl: 'logout-modal.html',
})
export class LogoutModalPage {

    myParam: string;
    company:string;
	  
	public texts : any = [];
    public language : string;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public viewCtrl: ViewController,
		public platform: Platform,
		public app: App
	) {
	}

	ionViewWillEnter() {
        this.company = localStorage.getItem("company");
		this.language = localStorage.getItem("language");

        this._get_texts();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).LogoutModal;
	} 

	_close() {
		// this.navCtrl.parent.select(this.navCtrl.parent.previousTab().index);
		this.viewCtrl.dismiss();
	}

	_exitApp() {
		this.viewCtrl.dismiss();
		localStorage.removeItem("loginId");
		localStorage.removeItem("api_key");
			
		//// Tab 페이지를 닫고 로그인 페이지로 이동
		//// 하단에 Tab 을 닫고자 할때 사용한다.
		this.app.getRootNav().setRoot(LoginPage);
        // this.navCtrl.setRoot(LoginPage);
	}

  

}



// WEBPACK FOOTER //
// ./src/pages/logout-modal/logout-modal.ts